module.exports = __webpack_public_path__ + "static/img/top-title.0270ce37.png";